import { createPinia } from 'pinia'
import { createApp, markRaw } from 'vue'
import { useAuthStore } from '@/stores/auth';
import router from '@/router';
import App from '@/layouts/App.vue';
import { i18n } from './i18n'
import '../css/app.css';
import websockets  from '@/lib/websockets.js'
const pinia = createPinia()
import { bootstrapPackages } from './lib/packageLoader';
pinia.use(({ store }) => {
  store.router = markRaw(router)
})

import axios from 'axios';
window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['Content-Type'] = 'application/json';
window.axios.defaults.headers.common['Accept'] = 'application/json';
window.axios.defaults.withCredentials = true;

window.axios.defaults.withXSRFToken = true;
const app = createApp(App)
  .use(pinia)
  .use(i18n)

app.config.globalProperties.$t = (...args) => i18n.global.t(...args)
app.config.globalProperties.$locale = i18n.global.locale

const authStore = useAuthStore()
bootstrapPackages({
  app,
  pinia,
  router,
  i18n
});
authStore.attempt_user()
  .catch((error) => {
    console.log('Please login.')
  })
  .finally(() => {
    app.use(router)
      .mount('#app');
  })

websockets.websocketsInit()
